/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * List of the different users related with the vehicle
 */
export interface VehicleUserResult { 
    idHashuser?: string;
    /**
     * The relationship of the user with the vehicle. OWNER, AUTHORIZED,...
     */
    role?: string;
    /**
     * IdHash of the user the vehicle is related.
     */
    idHashUser?: string;
}

